import '../../style/base.css';
import '../../loading/index.css';
import '../../picker/index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/area/style/index.js
// module id = 163
// module chunks = 31